<template>
    <div class="typification-actions">
        <h4 class="typification-actions__title color--green">{{ $t('global.afterTyping') }}</h4>
        <div class="typification-actions__content display--flex">
            <base-button
                v-for="button in buttons"
                type="button"
                :class="[
                    'typification-actions__button background--transparent accessibility--button',
                    { 'typification-actions__button--active color--green': workflow === button }
                ]"
                v-html="$t(`global.${button}`)"
                @click="() => $parent.$emit( `trigger-${button}` )"
                :key="button"
            />
        </div>
    </div>
</template>

<script>
export default {
    components: {
        BaseButton: () => import( /* webpackChunkName: 'BaseButton' */ '@/components/bundles/buttons/BaseButton' )
    },
    props: {
        workflow: String
    },
    setup () {
        // definições dos botões
        const buttons = [ 'pause', 'leave' ];

        return { buttons };
    }
};
</script>

<style lang="scss" scoped>
    .typification-actions {
        @include typography-specs( 16px, 21px, 200 );
        &__title {
            margin-bottom: 20px;
        }
        &__button {
            height: auto;
            padding: 5px 10px;
            border: 1px solid $color-default;
            &--active {
                border-color: $color-green;
            }
        }
        &__content > &__button {
            margin-left: 5px;
        }
    }
</style>